var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueToggles',{attrs:{"value":_vm.enabled,"height":"26","width":"48","checkedBg":"#1490ef","uncheckedBg":"#d5dbe3"},on:{"click":_vm.toggleClickHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }